import { Logger as AWSLogger } from '@aws-amplify/core'

const logger = new AWSLogger('getting-focused-app')

// To turn on debug logging, type this in the console or uncomment to get DEBUG all the time
window.LOG_LEVEL = 'INFO'

class Logger {
  debug(...msg) {
    logger.debug(...msg)
  }

  info(...msg) {
    logger.info(...msg)
  }

  warn(...msg) {
    logger.warn(...msg)
  }

  error(...msg) {
    logger.error(...msg)
  }
}

const LOG = new Logger()
export default LOG
